<template>
  <!-- 손님 결제 QR과 금액, 결제 기다림 표시(컨셉 변경 차액·당일 현장 추가 창이 함께 쓴다). 아래 안내 줄은 쓰는 창이 넣는다. -->
  <div>
    <div class="qr-frame" role="img" :aria-label="`손님 결제 QR, ${amountText}`">
      <vue-qrcode :value="url" :options="{ width: 232, margin: 1 }" />
    </div>
    <div class="qr-amount">{{ amountText }}</div>
    <p class="d-flex align-center justify-center text-body-2 font-weight-bold mb-1" aria-hidden="true">
      <v-progress-circular indeterminate size="16" width="2" color="#7d1832" class="qr-wait-spinner mr-2" />
      {{ waiting }}
    </p>
    <p class="qr-note text-body-2 grey--text text--darken-1 mb-0"><slot /></p>
  </div>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode"

export default {
  name: "AddonPayQr",
  components: { VueQrcode },
  props: {
    url: { type: String, required: true },
    amountText: { type: String, required: true },
    waiting: { type: String, required: true },
  },
}
</script>

<style scoped>
.qr-frame {
  display: inline-block;
  padding: 10px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 2px 3px -1px rgba(0, 0, 0, 0.1);
  line-height: 0;
}
.qr-note >>> span {
  display: block;
  word-break: keep-all;
  text-wrap: balance;
}
/* 몇 분씩 도는 기다림 표시는 움직임 줄이기 설정이면 멈춘다(옆 글이 상태를 말한다) */
@media (prefers-reduced-motion: reduce) {
  .qr-wait-spinner {
    display: none !important;
  }
}
.qr-amount {
  margin: 14px 0 10px;
  font-size: 24px;
  font-weight: 800;
  color: #7d1832;
  font-variant-numeric: tabular-nums;
}
</style>
